import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { BlockOutlined } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuBannedUsersProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuBannedUsers = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuBannedUsersProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/banned-users?page=1&page_size=10"
        selected={pathname.startsWith('/live-chat/banned-users')}
      >
        <ListItemIcon>
          <BlockOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.bannedUsers',
          })}
        />
      </MenuItem>
    </div>
  )
}
